import { SelectOptionCardProps } from '@/components/molecules/select-option-card/select-option-card';
import { CheckboxOption } from '@/components/organisms/checkbox-group/checkbox-group';
import { FilterItem } from '@/components/organisms/filter-card-list/filter-card-list';

export interface DurationOptions extends SelectOptionCardProps {
  rangeSize: number;
}

export interface Room {
  childrenAges: (number | null)[];
  numberOfAdults: number;
  numberOfChildren: number;
}

export interface RoomsState {
  automaticRoomAssignment: boolean;
  rooms: Room[];
}

export interface LocationGroup {
  countryCode?: string;
  groupName: string;
  options: CheckboxOption[];
}

export enum SearchBarWrapperSectionType {
  AREA = 'AREA',
  BRAND = 'BRAND',
  DATE = 'DATE',
  DURATION = 'DURATION',
  LOCATIONS = 'LOCATIONS',
  PERSONS = 'PERSONS',
}

export interface AreaData {
  areas?: Content.Components['TravelPortalAvailableArea'][];
}

export interface DurationData {
  durationOptions: DurationOptions[];
}

export interface LocationData {
  destinationRegionIds?: string[];
  destinations?: string[];
  hotelIds?: string[];
  locations?: LocationGroup[];
  transportationOptions: FilterItem[];
}

export interface DateData {
  availableDates: Date[] | undefined;
  durationOptions?: DurationOptions[];
  maxDate?: Date | null;
  minDate?: Date | null;
  rangeSelect?: boolean;
  rangeSize?: number;
  selectedDate?: Date;
  selectedMaxDate?: Date;
}

export interface PersonsData {
  adultThreshold?: number;
  defaultAdultNumber?: number;
  maxPersons?: number;
  maxRooms?: number;
  roomDistributionWarning?: string;
  roomsState?: RoomsState;
}

export interface SearchBarWrapperSectionData {
  disabled?: boolean;
  dropdownData?:
    | AreaData
    | DateData
    | DurationData
    | LocationData
    | PersonsData;
  id: number;
  isActive?: boolean;
  isLoading?: boolean;
  isNotified?: boolean;
  label: string;
  placeholder?: string;
  type: SearchBarWrapperSectionType;
  value?: string[] | string;
}

export interface LocationChangeParameters {
  destinationRegions?: string[];
  destinations?: string[];
  hotels?: string[];
  locations?: LocationGroup[];
}

export interface SearchBarDefaultValues {
  adultsNumber?: string;
  adultsPerRoom?: string;
  childrenAges?: string[];
  childrenAgesPerRoom?: string;
  departureDate?: Date;
  departureId?: string;
  destinationIds?: string[] | null;
  destinationRegionIds?: string[] | null;
  durationType?: Content.Components['PeriodType'] | null;
}
